// The phone's own copy of your workouts, the upload queue, and saved API responses (docs/SCOPE.md, Offline).
// Everything is written here first; `dirty` records are waiting to upload.
import type { SetRecord, WorkoutRecord } from '@squats/shared';
import Dexie, { type EntityTable } from 'dexie';

type Local = {
  userId: string;
  /** 1 = changed here and not yet confirmed by the server. (IndexedDB can't index booleans.) */
  dirty: 0 | 1;
  /** Why the server refused it, if it did; it then stops retrying. */
  rejected?: string;
};
export type LocalWorkout = WorkoutRecord & Local;
export type LocalSet = SetRecord & Local;
export type CacheEntry = { key: string; userId: string; data: unknown; savedAt: number };

export const db = new Dexie('squats') as Dexie & {
  workouts: EntityTable<LocalWorkout, 'id'>;
  sets: EntityTable<LocalSet, 'id'>;
  cache: EntityTable<CacheEntry, 'key'>;
};

db.version(1).stores({
  workouts: 'id, [userId+date], dirty',
  sets: 'id, workoutId, [userId+exerciseId], dirty',
  cache: 'key',
});
// Workouts done together share a session (the planner logs everyone's sets on one phone).
db.version(2).stores({ workouts: 'id, [userId+date], dirty, sessionId' });

/** Drops everything saved on this device (signing out). */
export async function clearLocal() {
  await db.transaction('rw', db.workouts, db.sets, db.cache, async () => {
    await Promise.all([db.workouts.clear(), db.sets.clear(), db.cache.clear()]);
  });
}
